import React, { useEffect, useState } from 'react';
import {
  Container, Typography, Paper, Box, Chip, Button, CircularProgress,
  Divider, TextField, InputAdornment,
} from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import EmailIcon from '@mui/icons-material/Email';
import DoneIcon from '@mui/icons-material/Done';
import axios from 'axios';
import { useAuth } from '../../contexts/AuthContext';

const API = process.env.REACT_APP_API_URL || 'https://watchpassion.vercel.app/api';

export default function AdminMessagesPage() {
  const { authHeader } = useAuth();
  const [inquiries, setInquiries] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState('');

  useEffect(() => {
    axios.get(`${API}/inquiries/admin`, { headers: authHeader() })
      .then(r => setInquiries(r.data.inquiries || []))
      .catch(console.error)
      .finally(() => setLoading(false));
  }, []);

  const markReplied = async (id) => {
    await axios.patch(`${API}/inquiries/admin/${id}`, {}, { headers: authHeader() });
    setInquiries(prev => prev.map(i => i.id === id ? { ...i, replied: true } : i));
  };

  const filtered = inquiries.filter(i =>
    !search || [i.name, i.email, i.item_title, i.message].some(f => f?.toLowerCase().includes(search.toLowerCase()))
  );

  if (loading) return <Container sx={{ pt: 6, textAlign: 'center' }}><CircularProgress /></Container>;

  return (
    <Container maxWidth="md" sx={{ py: 4 }}>
      <Typography variant="h4" fontWeight="bold" gutterBottom>
        Messaggi <Chip label={inquiries.filter(i => !i.replied).length + ' non letti'} color="warning" size="small" sx={{ ml: 1 }} />
      </Typography>

      <TextField size="small" placeholder="Cerca..." value={search}
        onChange={e => setSearch(e.target.value)} sx={{ mb: 3, width: 300 }}
        InputProps={{ startAdornment: <InputAdornment position="start"><SearchIcon /></InputAdornment> }} />

      {filtered.length === 0 && (
        <Typography color="text.secondary">Nessun messaggio</Typography>
      )}

      {filtered.map(inq => (
        <Paper key={inq.id} sx={{ p: 3, mb: 2, borderLeft: inq.replied ? '4px solid #ccc' : '4px solid', borderLeftColor: inq.replied ? 'grey.300' : 'warning.main' }}>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
            <Box>
              <Typography fontWeight="bold">{inq.name || inq.email}</Typography>
              <Typography variant="body2" color="text.secondary">{inq.email}</Typography>
              {inq.phone && <Typography variant="body2" color="text.secondary">Tel: {inq.phone}</Typography>}
            </Box>
            <Box sx={{ textAlign: 'right' }}>
              <Typography variant="caption" color="text.secondary">
                {new Date(inq.created_at).toLocaleDateString('it-IT', { day: '2-digit', month: 'short', hour: '2-digit', minute: '2-digit' })}
              </Typography>
              {inq.replied && <Chip label="Risposto" color="default" size="small" sx={{ ml: 1 }} />}
            </Box>
          </Box>

          {inq.item_title && (
            <Box sx={{ mt: 1 }}>
              <Chip label={`Articolo: ${inq.item_title}`} size="small" color="primary" variant="outlined" />
            </Box>
          )}

          {inq.message && (
            <>
              <Divider sx={{ my: 1.5 }} />
              <Typography variant="body2">{inq.message}</Typography>
            </>
          )}

          <Box sx={{ mt: 2, display: 'flex', gap: 1 }}>
            <Button size="small" variant="outlined" startIcon={<EmailIcon />}
              href={`mailto:${inq.email}?subject=Re: ${inq.item_title || 'Richiesta info'}`}>
              Rispondi
            </Button>
            {!inq.replied && (
              <Button size="small" startIcon={<DoneIcon />} onClick={() => markReplied(inq.id)}>
                Segna risposto
              </Button>
            )}
          </Box>
        </Paper>
      ))}
    </Container>
  );
}
